module.exports = __webpack_public_path__ + "img/GAME_PICTURELOTUS.31130bae.jpg";